import { render, staticRenderFns } from "./PeopleListItem.vue?vue&type=template&id=dabdfe7a&"
import script from "./PeopleListItem.vue?vue&type=script&lang=js&"
export * from "./PeopleListItem.vue?vue&type=script&lang=js&"
import style0 from "./PeopleListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports